import React from "react"
import { motion } from "motion/react"

import { cn } from "@productlane/lib/src/cn"

interface EditorMenuInputProps {
	value: string
	onChange: (value: string) => void
	placeholder: string
	onEnter: () => void
	onEscape: () => void
	className?: string
	marginBottom?: number
}

export const EditorMenuInput: React.FC<EditorMenuInputProps> = ({
	value,
	onChange,
	placeholder,
	onEnter,
	onEscape,
	className,
	marginBottom = 4,
}) => {
	return (
		<motion.div
			className={cn(
				"mb-1 box-border flex h-8 items-center gap-3 overflow-hidden border-gray-200 px-2",
				className,
			)}
			initial={{ height: 0, marginBottom: 0, opacity: 0.4 }}
			animate={{ height: 32, marginBottom: marginBottom, opacity: 1 }}
			exit={{ height: 0, marginBottom: 0, opacity: 0.4 }}
			transition={{ duration: 0.1, ease: "linear" }}
		>
			<input
				type="text"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="w-full bg-transparent text-xs outline-none"
				autoFocus
				placeholder={placeholder}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						e.preventDefault()
						e.stopPropagation()
						onEnter()
					}

					if (e.key === "Escape") {
						e.preventDefault()
						e.stopPropagation()
						onEscape()
					}
				}}
			/>
		</motion.div>
	)
}
